import React, { useContext, useEffect } from 'react';
import styled from 'styled-components/macro';

import { LevelButtons, classes } from '@mirinae/react-ui';

import PageElements from '@mirinae/lessons/components/lesson/PageElements';
import PlayerContext from '@mirinae/lessons/modules/contexts/player';
import { lessonsPalette } from '@mirinae/lessons/modules/defines/styles';

const Footer = styled.div`
    display: flex;
    align-items: flex-start;
    padding-top: 10px;
    border-top: 1px solid #CECECE;
    position: absolute;
    justify-content: space-between;
    .${classes.desktop} & {
        left: 35px;
        right: 35px;
        bottom: 0;
        padding-bottom: 10px;
    }
    .${classes.mobile} & {
        left: 30px;
        right: 30px;
        bottom: 0;
        padding-bottom: 10px;
    }
`;
const Level = styled.div`
    svg {
        flex-shrink: 0;
        vertical-align: middle;
    }
    margin-right: 10px;
`;
const TagLine = styled.div`
    display: flex;
    flex-wrap: wrap;
`;
const Tag = styled.div`
    color: ${lessonsPalette.grey[0]};
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
    &:before {
        content: '#';
        margin-right: 5px;
        color: ${lessonsPalette.primary.main};
        font-style: italic;
        font-weight: 700;
        font-size: 18px;
        vertical-align: middle;
    }
    & {
        margin-right: 10px;
    }
`;

// the render for lesson start pages, with a main title in the body and a start button
//   but no next & back buttons, uses the standard elements renderer for the title, etc.
const StartPage = ({ page }) => {
    const player = useContext(PlayerContext);
    const lesson = player.currentLesson;

    // temporary for testing first-time help bubbles, clears out help-seen state
    // useEffect(() => {
    //     const keysToDelete = [];
    //     for (let i = 0; i < window.localStorage.length; i += 1) {
    //         const key = window.localStorage.key(i);
    //         if (window.localStorage.getItem(key) === 'help-seen')
    //             keysToDelete.push(key);
    //     }
    //     keysToDelete.forEach(k => window.localStorage.removeItem(k));
    // }, []);
    
    const MappedFooter = () => (
        <Footer>
            {lesson.levelTitle && <Level><LevelButtons width="50" height="20" level={lesson.levelTitle} /></Level>}
            {lesson.tags && (
                <TagLine>
                    {lesson.tags.split(' ').map(tag => (
                        <Tag key={tag}>
                            {tag.replace(/^#+/, '')}
                        </Tag>
                    ))}
                </TagLine>
            )}
        </Footer>
    );

    // use standard element layout, specializing for the footer area
    return <PageElements page={page} mapComponent={e => e.name === 'footer' && MappedFooter} paddingBottom={65} />;
};

export default StartPage;
